let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("6vzdH"), load("2Vzm6"), load("2F69B"), load("jRzT2"), load("gEi5K")]).then(() => parcelRequire('3nvKi'));